// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_BOOLEAN_YES_WITH_ADAPTERS = "s adapt\u00e9rmi";
export const STROLLER_BOOLEAN_YES_WITH_COMBO = "pri kombin\u00e1cii";
export const STROLLER_BOOLEAN_YES_WITHOUT_ADAPTERS = "bez adapt\u00e9rov";
